function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 11h2.5v2H3zM18.5 11H21v2h-2.5zM11 21v-2.5h2V21zM11 5.5V3h2v2.5z"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 6,
  stroke: "currentColor",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  fill: "currentColor",
  r: 3
}));

function SvgMyLocation(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLocation);
export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIj48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Im0zIDExaDIuNXYyaC0yLjV6Ii8+PHBhdGggZD0ibTE4LjUgMTFoMi41djJoLTIuNXoiLz48cGF0aCBkPSJtMTEgMjF2LTIuNWgydjIuNXoiLz48cGF0aCBkPSJtMTEgNS41di0yLjVoMnYyLjV6Ii8+PC9nPjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjYiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiLz48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiBmaWxsPSJjdXJyZW50Q29sb3IiIHI9IjMiLz48L2c+PC9zdmc+Cg==";
export { ForwardRef as ReactComponent };